/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-unused-vars */
import React, { createContext, useContext, useCallback, useEffect, useRef, useState } from 'react';
import { promiseFetchDataAuth } from 'crk-front-lib';
import { fetchDashData } from '../controllers/work-order';
import { drawPieChart, drawAreaChart } from '../controllers/dashboard';
import { useAuth } from '../use-auth';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { queryPlanDueOrder } from '../features/work-report-thunk';

import { OrderMonthView } from './order-month-view';

const numberFormat = Intl.NumberFormat('en-US');

export function Dashboard(props) {
  const auth = useAuth();
  const dispatch = useDispatch();
  const history = useHistory();

  // must defined in fuction
  // eslint-disable-next-line react-hooks/exhaustive-deps
  /*
  const tasks = [
    fetchCountOrder({period: 'THIS-MONTH', status: 'ACTIVE'}).catch(err => console.error(err)),
    fetchCountOrder({period: 'THIS-MONTH', status: 'FINISHED'}).catch(err => console.error(err)),
    fetchCountOrder({period: 'THIS-MONTH', status: 'WAIT'}).catch(err => console.error(err)),
    fetchSumProduced({period: 'THIS-MONTH'}).catch(err => console.error(err)),
    fetchSumProduced({period: 'THIS-YEAR'}).catch(err => console.error(err)),
    fetchSumProduced({period: '12M', group: 'M'}).catch(err => console.error(err)),
    fetchSumProduced({period: '12M', group: 'P'}).catch(err => console.error(err)),
  ];
  */
  const [data, setData] = useState({
    count_active: 0,
    count_finished: 0,
    count_wait: 0,
    finished_by_due: 0,
    sum_produced_month: 0,
    sum_produced_year: 0,
    sum_produced_by_month: [],
    sum_produced_by_product: [],
  })

  const [pieSlices, setPieSlices] = useState([]);
  const [drawChart, setDrawChart] = useState(true);

  useEffect(() => {
    if (!localStorage.getItem('access_token')) return;
    if (!drawChart) return;
    /* Too slow method
    Promise.all(tasks).then(values => {
      console.info(values);
      if(values.length < 6) return;

      const _data = {
        count_active: (values[0][0] && values[0][0].count) || 0,
        count_finished: (values[1][0] && values[1][0].count) || 0,
        count_wait: (values[2][0] && values[2][0].count) || 0,
        sum_produced_month: (values[3][0] && values[3][0].sum_produced_qty) || 0,
        sum_produced_year: (values[4][0] && values[4][0].sum_produced_qty) || 0,
        sum_produced_by_month: values[5],
        sum_produced_by_product: values[6],
      }

      if (_data.count_active === 0) {
        _data.finished_by_due = 0;
      } else {
        _data.finished_by_due = (_data.count_finished / (_data.count_active + _data.count_wait)) * 100;
      }

      setData(_data);

      const _pieValues = _data.sum_produced_by_product
      setPieSlices(_pieValues);

      drawPieChart(_pieValues);
      drawAreaChart();
    })
    .catch(err => {
      console.error(err);
    });
    */

    fetchDashData()
    .then(dashdata => {
      const _data = { ...dashdata };
      if (_data.finished_by_due && _data.finished_by_due > 0) {
        _data.finished_by_due = parseFloat(`${_data.finished_by_due}`).toFixed(2);
      }

      setData(_data);

      const _pieValues = _data.sum_produced_by_product
      setPieSlices(_pieValues);

      drawPieChart(_pieValues);
      // drawAreaChart();
    })
    .catch(err => {
      console.error(err);
    });
    
    // Ensure draw only once
    // while (tasks.length > 0) tasks.pop();
    // setDrawChart(false);
  }, [drawChart]);

  useEffect(() => {
    dispatch(queryPlanDueOrder())
    .then(result => {
      // console.info(result);
    });
  }, [dispatch])

  const handleCheckSubscr = useCallback(
    () => {
      // console.info(auth);
      const url = `${auth.config.storeUrl}/api/v2/subscribe/${auth.config.appId}/${auth.user.pkg_id}`;
      promiseFetchDataAuth(url)
      .then(res => {
        // console.info(res);
        if (res.pkg_age && res.pkg_expire) console.info(res.pkg_age, res.pkg_expire);
        if (res.pkg_age && res.pkg_age.match(/EXPIRE/i)) {
          var overExp = new Date();
          overExp.setDate(overExp.getDate() - 10);
          if (new Date(res.pkg_expire) < overExp) {
            window.location.href = auth.config.expireUrl;
          }
        }
      });
    },
    [auth],
  );

  useEffect(() => {
    if (!auth.config || !auth.config.appId) {
      fetch('/js/config.json')
      .then(res => res.json())
      .then(_cfg => {
        // console.info(_cfg);
        auth.config = _cfg;
      });
    }

    setTimeout(handleCheckSubscr, 3000);
  }, [auth, handleCheckSubscr]);

  const handleOpen = useCallback(
    (value) => {
      history.push(`/work-order/${value._id}`);
    },
    [history],
  );

  return (
    <div className="container-fluid">
      <div className="d-sm-flex align-items-center justify-content-between mb-4">
        <h1 className="h3 mb-0 text-gray-800">Dashboard</h1>
        {/*
        <a href="#" className="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm">
          <i className="fas fa-download fa-sm text-white-50"></i> Generate Report
        </a>
        */}
      </div>

      <div className="row">
        <div className="col-xl-3 col-md-6 mb-4">
          <div className="card border-left-primary shadow h-100 py-2">
            <div className="card-body">
              <div className="row no-gutters align-items-center">
                <div className="col mr-2">
                  <div className="text-lg font-weight-bold text-primary text-uppercase mb-1">ยอดผลิต (เดือนนี้)</div>
                  <div className="h5 mb-0 font-weight-bold text-gray-800">
                    {numberFormat.format(data.sum_produced_month)}
                  </div>
                </div>
                <div className="col-auto">
                  <i className="fas fa-calendar fa-2x text-gray-300"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-xl-3 col-md-6 mb-4">
          <div className="card border-left-success shadow h-100 py-2">
            <div className="card-body">
              <div className="row no-gutters align-items-center">
                <div className="col mr-2">
                  <div className="text-lg font-weight-bold text-success text-uppercase mb-1">ยอดผลิต (ปีนี้)</div>
                  <div className="h5 mb-0 font-weight-bold text-gray-800">
                    {numberFormat.format(data.sum_produced_year)}
                  </div>
                </div>
                <div className="col-auto">
                  <i className="fas baht-sign fa-2x text-gray-300"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-xl-3 col-md-6 mb-4">
          <div className="card border-left-info shadow h-100 py-2">
            <div className="card-body">
              <div className="row no-gutters align-items-center">
                <div className="col mr-2">
                  <div className="text-lg font-weight-bold text-info text-uppercase mb-1">งานตามกำหนดส่ง</div>
                  <div className="row no-gutters align-items-center">
                    <div className="col-auto">
                      <div className="h5 mb-0 mr-3 font-weight-bold text-gray-800">
                        {data.finished_by_due}%
                      </div>
                    </div>
                    <div className="col">
                      <div className="progress progress-sm mr-2">
                        <div
                          className="progress-bar bg-info"
                          role="progressbar"
                          style={{ width: `${data.finished_by_due}%` }}
                          aria-valuenow={data.finished_by_due}
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-auto">
                  <i className="fas fa-clipboard-list fa-2x text-gray-300"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-xl-3 col-md-6 mb-4">
          <div className="card border-left-warning shadow h-100 py-2">
            <div className="card-body">
              <div className="row no-gutters align-items-center">
                <div className="col mr-2">
                  <div className="text-lg font-weight-bold text-warning text-uppercase mb-1">งานรอผลิต</div>
                  <div className="h5 mb-0 font-weight-bold text-gray-800">
                    {numberFormat.format(data.count_wait)}
                  </div>
                </div>
                <div className="col-auto">
                  <i className="fas fa-comments fa-2x text-gray-300"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        {false && <div className="col-xl-8 col-lg-7">
          <div className="card shadow mb-4">
            <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
              <h6 className="m-0 font-weight-bold text-primary">ผลผลิตรายสัปดาห์</h6>
              <div className="dropdown no-arrow d-none">
                <a
                  className="dropdown-toggle"
                  href="#"
                  role="button"
                  id="dropdownMenuLink"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <i className="fas fa-ellipsis-v fa-sm fa-fw text-gray-400"></i>
                </a>
                <div
                  className="dropdown-menu dropdown-menu-right shadow animated--fade-in"
                  aria-labelledby="dropdownMenuLink"
                >
                  <div className="dropdown-header">Dropdown Header:</div>
                  <a className="dropdown-item" href="#">
                    Action
                  </a>
                  <a className="dropdown-item" href="#">
                    Another action
                  </a>
                  <div className="dropdown-divider"></div>
                  <a className="dropdown-item" href="#">
                    Something else here
                  </a>
                </div>
              </div>
            </div>

            <div className="card-body">
              <div className="chart-area">
                <canvas id="myAreaChart"></canvas>
              </div>
            </div>
          </div>
        </div>}

        <div className="col-xl-12 col-lg-12">
          <div className="card shadow mb-4">
            <div className="card-header py-3 d-flex flex-row align-items-center justify-content-between">
              <h6 className="m-0 font-weight-bold text-primary">สัดส่วนการผลิต (12 เดือน)</h6>
              <div className="dropdown no-arrow d-none">
                <a
                  className="dropdown-toggle"
                  href="#"
                  role="button"
                  id="dropdownMenuLink"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <i className="fas fa-ellipsis-v fa-sm fa-fw text-gray-400"></i>
                </a>
                <div
                  className="dropdown-menu dropdown-menu-right shadow animated--fade-in"
                  aria-labelledby="dropdownMenuLink"
                >
                  <div className="dropdown-header">Dropdown Header:</div>
                  <a className="dropdown-item" href="#">
                    Action
                  </a>
                  <a className="dropdown-item" href="#">
                    Another action
                  </a>
                  <div className="dropdown-divider"></div>
                  <a className="dropdown-item" href="#">
                    Something else here
                  </a>
                </div>
              </div>
            </div>

            <div className="card-body">
              <div className="chart-pie pt-4 pb-2">
                <canvas id="myPieChart"></canvas>
              </div>
              <div className="mt-4 text-center small">
                <span className="mr-2">
                  <i className="fas fa-circle text-primary"></i> {pieSlices[0] && pieSlices[0]._id}
                </span>
                <span className="mr-2">
                  <i className="fas fa-circle text-success"></i> {pieSlices[1] && pieSlices[1]._id}
                </span>
                <span className="mr-2">
                  <i className="fas fa-circle text-secondary" style={{color: 'lightgrey !important'}}></i> อื่น ๆ
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <OrderMonthView onOpen={handleOpen} />

      <div className="row">
        {/*
        <div className="col-lg-6 mb-4">
          <div className="card shadow mb-4">
            <div className="card-header py-3">
              <h6 className="m-0 font-weight-bold text-primary">Projects</h6>
            </div>
            <div className="card-body">
              <h4 className="small font-weight-bold">
                Server Migration <span className="float-right">20%</span>
              </h4>
              <div className="progress mb-4">
                <div
                  className="progress-bar bg-danger"
                  role="progressbar"
                  style={{ width: '20%' }}
                  aria-valuenow="20"
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>
              <h4 className="small font-weight-bold">
                Sales Tracking <span className="float-right">40%</span>
              </h4>
              <div className="progress mb-4">
                <div
                  className="progress-bar bg-warning"
                  role="progressbar"
                  style={{ width: '40%' }}
                  aria-valuenow="40"
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>
              <h4 className="small font-weight-bold">
                Customer Database <span className="float-right">60%</span>
              </h4>
              <div className="progress mb-4">
                <div
                  className="progress-bar"
                  role="progressbar"
                  style={{ width: '60%' }}
                  aria-valuenow="60"
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>
              <h4 className="small font-weight-bold">
                Payout Details <span className="float-right">80%</span>
              </h4>
              <div className="progress mb-4">
                <div
                  className="progress-bar bg-info"
                  role="progressbar"
                  style={{ width: '80%' }}
                  aria-valuenow="80"
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>
              <h4 className="small font-weight-bold">
                Account Setup <span className="float-right">Complete!</span>
              </h4>
              <div className="progress">
                <div
                  className="progress-bar bg-success"
                  role="progressbar"
                  style={{ width: '100%' }}
                  aria-valuenow="100"
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>
            </div>
          </div>
        </div>
        */}
        {/*
        <div className="col-lg-6 mb-4">

          <div className="card shadow mb-4">
            <div className="card-header py-3">
              <h6 className="m-0 font-weight-bold text-primary">Illustrations</h6>
            </div>
            <div className="card-body">
              <div className="text-center">
                <img
                  className="img-fluid px-3 px-sm-4 mt-3 mb-4"
                  style={{ width: '25rem' }}
                  src="img/undraw_posting_photo.svg"
                  alt=""
                />
              </div>
              <p>
                Add some quality, svg illustrations to your project courtesy of{' '}
                <a target="_blank" rel="nofollow" href="https://undraw.co/">
                  unDraw
                </a>
                , a constantly updated collection of beautiful svg images that you can use completely free and without
                attribution!
              </p>
              <a target="_blank" rel="nofollow" href="https://undraw.co/">
                Browse Illustrations on unDraw &rarr;
              </a>
            </div>
          </div>

        </div>
        */}
      </div>
    </div>
  );
}

/**
<!-- Custom scripts for all pages-->
<!-- <script src="js/sb-admin-2.js"></script> -->

<!-- Page level plugins -->
<script src="vendor/chart.js/Chart.min.js"></script>

<!-- Page level custom scripts -->
<script src="js/demo/chart-area-demo.js"></script>
<script src="js/demo/chart-pie-demo.js"></script>
 */
